var render, staticRenderFns
import script from "./cart-item.vue?vue&type=script&lang=js&"
export * from "./cart-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454035a0')) {
      api.createRecord('454035a0', component.options)
    } else {
      api.reload('454035a0', component.options)
    }
    
  }
}
component.options.__file = "resources/components/cart-item/cart-item.vue"
export default component.exports